import { render, staticRenderFns } from "./UserAnchors.vue?vue&type=template&id=4a28e2ce&"
import script from "./UserAnchors.vue?vue&type=script&lang=js&"
export * from "./UserAnchors.vue?vue&type=script&lang=js&"
import style0 from "./UserAnchors.vue?vue&type=style&index=0&id=4a28e2ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports